import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  style: {"margin-top":"55px","height":"400px"},
  class: "w100 posRe ofs"
}
const _hoisted_3 = { class: "fs28 ls1 mc centered fw600" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "w100" }
const _hoisted_6 = { class: "w100 posRe" }
const _hoisted_7 = {
  for: "uploadText",
  class: "UploadImageButton centered pointer posRe fl ddgreyBg",
  style: `height: 120px; width: 120px;`
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  class: /*#__PURE__*/_normalizeClass(`fs14 centered mt5 fw600 whiteColor pad5`),
  style: {"margin-top":"40px"}
}, " ファイルをアップロード ", -1)
const _hoisted_9 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_10 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_11 = {
  class: "posAb w30 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "posAb w70 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, " 保存 ", -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_SelectableImage = _resolveComponent("SelectableImage")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "FileBoardModal",
    "content-class": "rad10 with_white_bg ofs shadowContent modalWide noscroll w100",
    onBeforeOpen: _ctx.openModal,
    onBeforeClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        class: "dismiss",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
          width: "50",
          height: "50"
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("div", {
        style: {"margin-top":"15px","height":"90vh"},
        class: _normalizeClass(`w100 ${_ctx.isDrag == `new` ? 'dragging lskyblueBg' : ``}`),
        onDragover: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', true)), ["prevent"])),
        onDragleave: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.checkDrag($event, 'new', false)), ["prevent"])),
        onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title || `ファイルを選択`), 1),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("input", {
                  type: "file",
                  class: "drop__input",
                  style: {"display":"none"},
                  id: "uploadText",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
                }, null, 32)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFiles, (file, fileindex) => {
                return (_openBlock(), _createBlock(_component_SelectableImage, {
                  key: fileindex,
                  file: file,
                  width: 120,
                  selected: _ctx.beforeId == file.file_id,
                  canDelete: true,
                  class: "fl posRe",
                  onMouseoverImage: _ctx.mouseoverFile,
                  onMouseleaveImage: _ctx.mouseleaveFile,
                  onChange: _ctx.changeFile,
                  onDeleteImage: _ctx.deleteImage
                }, null, 8, ["file", "selected", "onMouseoverImage", "onMouseleaveImage", "onChange", "onDeleteImage"]))
              }), 128))
            ])
          ])
        ])
      ], 34),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("section", {
              class: "llgreyBg dgrey fs16 pointer centered",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
            }, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("section", {
              class: _normalizeClass(`${_ctx.selectedFile ? `skyblueBg` : `llgreyBg`} w100 fs16 pointer centered`),
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
            }, _hoisted_16, 2)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onBeforeClose"]))
}